/**
 * Technique API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';
import CategoryParameter from './CategoryParameter';


class CategoryEdit {
    
    constructor(title, description, parameters) { 
        
        CategoryEdit.initialize(this, title, description, parameters);
    }

    
    static initialize(obj, title, description, parameters) { 
        obj['title'] = title;
        obj['description'] = description;
        obj['parameters'] = parameters;
    }

    
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new CategoryEdit();

            if (data.hasOwnProperty('title')) {
                obj['title'] = ApiClient.convertToType(data['title'], 'String');
            }
            if (data.hasOwnProperty('description')) {
                obj['description'] = ApiClient.convertToType(data['description'], 'String');
            }
            if (data.hasOwnProperty('parent')) {
                obj['parent'] = ApiClient.convertToType(data['parent'], 'Number');
            }
            if (data.hasOwnProperty('parameters')) {
                obj['parameters'] = ApiClient.convertToType(data['parameters'], [CategoryParameter]);
            }
        }
        return obj;
    }


}


CategoryEdit.prototype['title'] = undefined;


CategoryEdit.prototype['description'] = undefined;


CategoryEdit.prototype['parent'] = undefined;


CategoryEdit.prototype['parameters'] = undefined;






export default CategoryEdit;

